function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import Div from "../htmlTags/Div";
const StyledTool = styled(Div)`
  && {
    width: 100%;
    padding: .2rem 1rem;
    white-space: nowrap;
    text-transform: capitalize;
    cursor: pointer;
  }
  
  &&:hover {
  }
`;
export const SideAction = ({
  color,
  children,
  onClick,
  ...restProps
}) => {
  let className = 'side-action';
  if (color === 'contrast') className = 'side-action-contrast';
  return /*#__PURE__*/React.createElement(StyledTool, _extends({
    variant: "contained",
    onMouseDown: onClick,
    className: className
  }, restProps), children);
};